import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          const serverMessage = (error.error &&
            (error.error.message || error.error.Message)) as string | undefined;
          const message = serverMessage || error.message || `${error.status}`;
          // Show a toast for the error
          try {
            this.toastr.error(message, 'Request failed', {
              disableTimeOut: true,
            });
          } catch (e) {
            // swallow any toastr errors to avoid infinite loops
            // eslint-disable-next-line no-console
            console.error('Toastr error while showing HTTP error', e);
          }
        }

        return throwError(() => error as any);
      })
    );
  }
}
